import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SettingsContext = createContext(null);

const DEFAULT_FEATURES = {
  featured_listings: true, property_comparison: true, whatsapp_share: true,
  views_counter: true, enquiry_tracker: true, revenue_dashboard: true,
  broadcast: true, report_listing: true, video_walkthrough: true,
  emi_calculator: true, price_history: true,
  offers: true, carousel: true, card_banners: true, home_loans: true,
  whatsapp_enquiry: true, broker_referrals: true, nearby_properties: true,
  loan_self_registration: true, loan_provider_strip: true,
  role_switch_request: true, broker_security_alerts: true,
  launch_page: true, broker_profile_edit: true, auto_logout: true,
  search_by_id: true, property_id_display: true, assignment_chat: true,
  communication_profile: true, staff_property_upload: true,
  search_filters: true,
};

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const uid = user ? user.id : user;
  const [settings, setSettings] = useState({ features: DEFAULT_FEATURES, broadcast_text: "", broadcast_active: false, marquee_text: "", marquee_active: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings({ ...data, features: { ...DEFAULT_FEATURES, ...(data.features || {}) } });
    } catch (e) { console.debug("settings refresh failed, keeping defaults", e); }
  }, []);

  useEffect(() => { if (uid !== null) { refresh(); } }, [refresh, uid]);

  const feature = (name) => settings.features?.[name] !== false;

  return (
    <SettingsContext.Provider value={{ settings, feature, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
